export const testimonialsData = [
    {
        content: 'All the Lorem Ipsum generators on the Internet tend to repeat, making this the first true generator on the Internet.',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Alex Dolgove',
        title: 'BDM G-axon'
    }, {
        content: 'Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like)',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Domnic Brown',
        title: 'Product Head'
    }, {
        content: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Jeson Born',
        title: 'Director, Abc LLC'
    }, {
        content: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, ',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'John Smith',
        title: 'Chief Engineer'
    }, {
        content: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Min Chan',
        title: 'Director, Abc LLC'
    }, {
        content: 'It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Stella Johnson',
        title: 'Engineer Lead'
    }, {
        content: 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections ',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Steve Smith',
        title: 'Director, Abc LLC'
    }
];
export const basicTestimonialsData = [
    {
        content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Alex Dolgove',
        title: 'BDM G-axon'
    }, {
        content: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \'Content here, content here\', making it look like readable English.',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Domnic Brown',
        title: 'Product Head'
    }, {
        content: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Jeson Born',
        title: 'Director, Abc LLC'
    }, {
        content: ' All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'John Smith',
        title: 'Chief Engineer'
    }, {
        content: 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don\'t look even slightly believable.',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Min Chan',
        title: 'Director, Abc LLC'
    }, {
        content: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Stella Johnson',
        title: 'Engineer Lead'
    }, {
        content: 'The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections ',
        avatar: 'http://via.placeholder.com/256x256',
        name: 'Steve Smith',
        title: 'Director, Abc LLC'
    }
];


// WEBPACK FOOTER //
// ./app/routes/extraElements/routes/testimonials/testimonialsData.js